import React, { useState } from "react";
import { Server, Terminal as TerminalIcon } from "lucide-react";
import { useTopology } from "../TopologyContext";
import Terminal from "./Terminal";

// Sidebar node picker + single live terminal pane.
// Picking a different node remounts the Terminal (via key={selected}),
// which tears down the previous WebSocket and opens a new one.
export default function TerminalDashboard() {
  const { ALL_NODES, CLUSTERS, NODE_TO_CLUSTER } = useTopology();
  const [selected, setSelected] = useState("master");

  const clusterEntries = Object.entries(CLUSTERS || {});
  const orphans = (ALL_NODES || []).filter(n => !NODE_TO_CLUSTER?.[n]);

  return (
    <div style={{
      display: "flex", gap: 12, height: "calc(100vh - 180px)",
    }}>
      {/* Sidebar */}
      <aside style={{
        width: 230, flexShrink: 0, overflowY: "auto",
        backgroundColor: "#0d1424", border: "1px solid #1f2937",
        borderRadius: 8, padding: 10,
      }}>
        <SidebarItem
          label="master"
          sublabel="10.128.97.9"
          color="#3b82f6"
          icon={<TerminalIcon size={14} />}
          active={selected === "master"}
          onClick={() => setSelected("master")}
        />

        {clusterEntries.map(([cid, c]) => (
          <div key={cid} style={{ marginTop: 14 }}>
            <div style={{
              fontSize: 11, color: c.color || "#9ca3af",
              textTransform: "uppercase", letterSpacing: 0.5,
              padding: "4px 6px", fontWeight: 600,
            }}>
              {c.label || `Cluster ${cid}`}
            </div>
            {(c.members || []).map(n => (
              <SidebarItem
                key={n}
                label={n}
                sublabel={n === c.head ? "head" : null}
                color={c.color || "#22d3ee"}
                icon={<Server size={14} />}
                active={selected === n}
                onClick={() => setSelected(n)}
              />
            ))}
          </div>
        ))}

        {orphans.length > 0 && (
          <div style={{ marginTop: 14 }}>
            <div style={{
              fontSize: 11, color: "#9ca3af",
              textTransform: "uppercase", letterSpacing: 0.5,
              padding: "4px 6px", fontWeight: 600,
            }}>
              Other
            </div>
            {orphans.map(n => (
              <SidebarItem
                key={n}
                label={n}
                color="#9ca3af"
                icon={<Server size={14} />}
                active={selected === n}
                onClick={() => setSelected(n)}
              />
            ))}
          </div>
        )}
      </aside>

      {/* Terminal pane — remount when selected changes */}
      <div style={{ flex: 1, minWidth: 0 }}>
        <Terminal key={selected} node={selected} />
      </div>
    </div>
  );
}

function SidebarItem({ label, sublabel, color, icon, active, onClick }) {
  return (
    <button
      onClick={onClick}
      style={{
        display: "flex", alignItems: "center", gap: 8,
        width: "100%", textAlign: "left",
        padding: "8px 10px", marginTop: 2,
        border: "1px solid transparent",
        borderRadius: 6,
        background: active ? "rgba(59,130,246,0.15)" : "transparent",
        borderColor: active ? "#3b82f6" : "transparent",
        color: active ? "#fff" : "#d1d5db",
        cursor: "pointer",
        fontSize: 13,
        fontFamily: "monospace",
      }}
      onMouseEnter={e => { if (!active) e.currentTarget.style.background = "rgba(148,163,184,0.08)"; }}
      onMouseLeave={e => { if (!active) e.currentTarget.style.background = "transparent"; }}
    >
      <span style={{ color, display: "inline-flex" }}>{icon}</span>
      <span style={{ flex: 1 }}>{label}</span>
      {sublabel && (
        <span style={{ fontSize: 10, color: "#6b7280" }}>{sublabel}</span>
      )}
    </button>
  );
}
